<template>
  <div class="content nfs-page">
    <!-- ============================================================
         TOOLBAR CARD: Bộ lọc
         ============================================================ -->
    <div class="row-data nfs-toolbar-card">
      <div class="nfs-card-head">
        <div>
          <p class="nfs-card-title">Tin tức lớp học</p>
          <p class="nfs-card-subtitle">Tìm kiếm các thông báo, tin tức cấp lớp học do giáo viên đăng tải.</p>
        </div>
      </div>

      <el-form
        ref="searchFormRef"
        :model="dataSearch"
        label-position="top"
        class="nfs-form-grid"
      >
        <el-form-item label="Hiển thị" class="nfs-form-item">
          <el-select
              style="width: 140px"
              v-model="dataSearch.active"
              @change="searchHeaderMethod()"
              clearable
              placeholder="Hiển thị"
          >
            <el-option
                v-for="item in activeList"
                :key="item.key"
                :value="item.key"
                :label="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Phạm vi" class="nfs-form-item">
          <el-select
              disabled
              style="width: 140px"
              v-model="dataSearch.scope"
              @change="searchHeaderMethod()"
              clearable
              placeholder="Phạm vi"
          >
            <el-option
                v-for="item in scopeList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Thời gian tạo" class="nfs-form-item">
          <el-date-picker
              style="width: 260px"
              value-format="yyyy-MM-dd"
              format="dd-MM-yyyy"
              v-model="dataSearch.dateList"
              type="daterange"
              unlink-panels
              range-separator="-"
              @change="searchHeaderMethod()"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="Tìm kiếm tiêu đề" class="nfs-form-item">
          <el-input
              style="width: 270px"
              placeholder="Nhập tiêu đề tìm kiếm"
              clearable
              v-model="dataSearch.title"
              @keyup.enter.native="searchHeaderMethod()"
              @clear="searchHeaderMethod()"
          >
            <template #append>
              <el-button
                  icon="el-icon-search"
                  @click="searchHeaderMethod()"
              ></el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <!-- ============================================================
         TABLE CARD: Danh sách tin tức
         ============================================================ -->
    <div class="row-data nfs-table-card">
      <div class="nfs-card-head">
        <div>
          <p class="nfs-card-title">Danh sách bản tin</p>
          <p class="nfs-card-subtitle">Hiển thị thông tin người gửi, số tệp đính kèm và các cấu hình trạng thái của tin tức.</p>
        </div>
        <div class="button-click">
          <el-button class="button-over" type="primary" @click="createNotifyDialog()">
            <i class="el-icon-plus"/>
            Tạo tin tức
          </el-button>
        </div>
      </div>

      <div class="nfs-table-wrapper">
        <el-table
            :empty-text="textTable"
            v-loading="loadingData"
            :element-loading-text="$tableLoading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255, 0)"
            :data="responseDataList"
            highlight-current-row
            class="sk-table"
            @selection-change="handleSelectionChange"
            border
            :max-height="$tableMaxHeight"
        >
          <!-- STT -->
          <el-table-column
              type="index"
              label="STT"
              width="50"
              align="center"
          />

          <!-- Thời gian -->
          <el-table-column
              prop="createdDate"
              width="155px"
              label="Thời gian tạo"
              align="center"
          >
            <template v-slot:default="scope">
              <span>{{ scope.row.createdDate | formatDateTime }}</span>
            </template>
          </el-table-column>

          <!-- Người gửi -->
          <el-table-column width="160px" label="Người gửi" prop="createdBy">
            <template v-slot:default="scope">
              <span class="font-semibold text-slate-700">{{ scope.row.createdBy }}</span>
            </template>
          </el-table-column>

          <!-- Phạm vi -->
          <el-table-column
              prop="scope"
              label="Phạm vi"
              width="100px"
              align="center"
          >
            <template v-slot:default="scope">
              <span>{{ formatScope(scope.row.scope) }}</span>
            </template>
          </el-table-column>

          <!-- Tiêu đề -->
          <el-table-column
              prop="title"
              label="Tiêu đề"
              min-width="250px"
          >
            <template v-slot:default="scope">
              <span class="nfs-title-link" @click="handleEdit(scope.row)">
                {{ scope.row.title }}
              </span>
            </template>
          </el-table-column>

          <!-- Số File -->
          <el-table-column width="100px" label="Số File" align="center">
            <template v-slot:default="scope">
              <span v-if="scope.row.notifySchoolAttachFileList && scope.row.notifySchoolAttachFileList.length > 0" class="nfs-file-badge">
                <i class="el-icon-document" />
                {{ scope.row.notifySchoolAttachFileList.length }}
              </span>
              <span v-else class="text-slate-400">—</span>
            </template>
          </el-table-column>

          <!-- Hiển thị -->
          <el-table-column prop="active" width="100px" label="Hiển thị" align="center">
            <template v-slot:default="scope">
              <el-checkbox
                  class="nfs-table-checkbox"
                  :disabled="(checkCountActive === checkedCount && scope.row.active === true) || scope.row.approved === false"
                  v-model="scope.row.active"
                  @change="getActiveNotifyTeacher(scope.row)"
              ></el-checkbox>
            </template>
          </el-table-column>

          <!-- Duyệt -->
          <el-table-column prop="approved" width="100px" label="Duyệt" align="center">
            <template v-slot:default="scope">
              <el-checkbox
                  disabled
                  class="nfs-table-checkbox"
                  v-model="scope.row.approved"
              ></el-checkbox>
            </template>
          </el-table-column>

          <!-- Thời gian gửi -->
          <el-table-column
              width="155px"
              label="Thời gian gửi"
              align="center"
          >
            <template v-slot:default="scope">
              <span v-if="scope.row.scheduledTime">{{ scope.row.scheduledTime | formatDateTime }}</span>
              <span v-else class="text-slate-400">—</span>
            </template>
          </el-table-column>

          <!-- Trạng thái gửi -->
          <el-table-column
              width="135px"
              label="Trạng thái gửi"
              align="center"
          >
            <template v-slot:default="scope">
              <span :class="getStatusBadgeClass(scope.row)">
                {{ formatNotifySendStatus(scope.row) }}
              </span>
            </template>
          </el-table-column>

          <!-- Ghim -->
<!--          <el-table-column-->
<!--              label="Ghim"-->
<!--              align="center"-->
<!--              width="90px"-->
<!--          >-->
<!--            <template v-slot:default="scope">-->
<!--              <el-checkbox-->
<!--                  class="nfs-table-checkbox nfs-table-checkbox&#45;&#45;pin"-->
<!--                  v-model="scope.row.pin"-->
<!--                  @change="(value) => handleChangePin(scope.row, value)"-->
<!--                  :disabled="!scope.row.pin && countPostPin >= 5"-->
<!--              />-->
<!--            </template>-->
<!--          </el-table-column>-->

          <!-- Tác vụ -->
          <el-table-column label="Tác vụ" fixed="right" width="120px" align="center">
            <template slot-scope="{ row }">
              <el-tooltip content="Chỉnh sửa tin tức" placement="top">
                <el-button 
                  type="primary" 
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  plain
                  @click="handleEdit(row)"
                />
              </el-tooltip>
              <el-tooltip content="Xóa tin tức" placement="top">
                <el-button 
                  type="danger" 
                  icon="el-icon-delete"
                  size="mini"
                  circle
                  plain
                  class="ml-1"
                  @click="handleDelete(row)"
                />
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- Phân trang -->
      <div class="nfs-pagination">
        <el-pagination
            background
            :current-page="pageNumber"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="$pageListDefaultNew"
            :page-size="maxPageItem"
            :layout="$pageLayoutDefault"
            :total="pageTotal"
        ></el-pagination>
      </div>
    </div>

    <!-- Dialogs -->
    <CreateNotifyTeacher
        :dialogVisible="showCreateDialog"
        @dialog-close="dialogCloseCreateMethod()"
        ref="CreateNotifyTeacher"
    />
    <UpdateNotifyTeacher
        :dialogVisible="showUpdateDialog"
        @dialog-close="dialogCloseUpdateMethod()"
        ref="UpdateNotifyTeacher"
    />

    <SetTimePostPinTeacherExpiration
        :is-dialog-visible="isDialogVisible.setTimePostPin"
        @dialogClose="handleDialogSetTimeClose"
        ref="SetTimePostPinTeacherExpiration"
    />
  </div>
</template>

<script>
import NotifyTeacherService from "@/services/TeacherService/NotifyTeacherService";
import CreateNotifyTeacher from "./CreateNotifyTeacher.vue";
import UpdateNotifyTeacher from "./UpdateNotifyTeacher.vue";
import SetTimePostPinTeacherExpiration from "./SetTimePostPinTeacherExpiration.vue";
import { notifySendType } from "../../constant/listCommon";

export default {
  name: "NotifyTeacher",
  components: {SetTimePostPinTeacherExpiration, CreateNotifyTeacher, UpdateNotifyTeacher},
  data() {
    return {
      loadingData: true,
      textTable: "",
      pageTotal: this.$pageTotalDefault,
      maxPageItem: this.$pageSizeDefaultNew,
      pageNumber: 1,
      checkCountActive: 0,
      checkedCount: 0,
      responseDataList: [],
      multipleSelection: [],
      showCreateDialog: false,
      showUpdateDialog: false,
      activeList: [
        {key: true, value: "Đã hiển thị"},
        {key: false, value: "Chưa hiển thị"},
      ],
      scopeList: [
        {value: "SCHOOL", label: "Trường"},
        {value: "CLASS", label: "Lớp"},
      ],
      dataSearch: {
        active: "",
        dateList: "",
        title: "",
        content: "",
        scope: "CLASS",
      },
      isDialogVisible: {
        setTimePostPin: false,
      },
      countPostPin: undefined,
    };
  },
  methods: {
    formatScope(scope) {
      if (!scope) return "—";
      const upperScope = scope.toUpperCase();
      if (upperScope === "SCHOOL") return "Trường";
      if (upperScope === "CLASS") return "Lớp";
      if (upperScope === "EMPLOYEE") return "Nhân sự";
      if (upperScope === "ALL") return "Tất cả";
      return scope;
    },
    formatNotifySendStatus(row){
      if(row.sendType === notifySendType.SUCCESS){
        return "Đã gửi";
      } 
      if(row.sendType === notifySendType.FAIL){
        return "Gửi thất bại";
      }
      return "Đang chờ"
    },
    getStatusBadgeClass(row) {
      if (row.sendType === notifySendType.SUCCESS) {
        return "nfs-badge nfs-badge--success";
      }
      if (row.sendType === notifySendType.FAIL) {
        return "nfs-badge nfs-badge--danger";
      }
      return "nfs-badge nfs-badge--warning";
    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
      this.searchByProperties();
    },
    dialogCloseUpdateMethod() {
      this.showUpdateDialog = false;
      this.searchByProperties();
    },
    dialogCloseListReceiverMethod() {
      this.showListReceiver = false;
    },
    dialogCloseViewContentMethod() {
      this.showContentNotify = false;
    },
    tableHeaderColor() {
      return "background-color: #2563eb;color: #fff;font-weight: bold";
    },
    handleSizeChange(maxPageItem) {
      this.maxPageItem = maxPageItem;
      this.searchByProperties();
    },
    handleCurrentChange(pageNumber) {
      this.pageNumber = pageNumber;
      this.searchByProperties();
    },
    handleSendNotify(command) {
      let listNotify = this.multipleSelection;
      if (listNotify.length === 0) {
        this.$message({
          message: "Không có thông báo nào được chọn",
          type: "error",
        });
        return;
      }
      if (command === "deleteNotifyApp") {
        this.deleteNotifyApp(listNotify);
      }
    },
    createNotifyDialog() {
      this.showCreateDialog = true;
    },
    handleEdit(row) {
      this.showUpdateDialog = true;
      this.$refs.UpdateNotifyTeacher.getDataInitial(row.id);
    },
    handleViewDetail(index, row) {
      this.sendContentNotify = row.sendContent;
      this.showContentNotify = true;
    },
    handleDelete(row) {
      this.$confirm("Bạn có chắc chắn muốn xóa tin tức đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        NotifyTeacherService.deleteNotifyTeacher(row.id)
            .then((response) => {
              this.$message({
                message: response.data.message,
                type: "success",
              });
              this.searchByProperties();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            });
      });
    },
    clickTitle(row) {
      this.showUpdateDialog = true;
      this.$refs.UpdateNotifyTeacher.getDataInitial(row.id);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    searchHeaderMethod() {
      this.pageNumber = 1;
      this.searchByProperties();
    },
    async searchByProperties() {
      if (this.dataSearch.dateList == null) {
        this.dataSearch.dateList = "";
      }
      this.loadingData = true;
      await NotifyTeacherService.searchNotifyTeacher(
          this.pageNumber,
          this.maxPageItem,
          this.dataSearch.active,
          this.dataSearch.dateList,
          this.dataSearch.title,
          this.dataSearch.content,
          this.dataSearch.scope
      )
          .then((resp) => {
            const data = resp.data.data;
            this.responseDataList = data.dataList;
            this.pageTotal = data.total;
            this.countPostPin = data.numberOfPinnedPosts;
          })
          .catch((err) => {
            this.pageTotal = 1;
            this.responseDataList = [];
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            if (this.responseDataList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            this.loadingData = false;
          });
      await this.getCheckCount()
      await NotifyTeacherService.checkNewConfigCount()
          .then((resp) => {
            this.checkCountActive = resp.data.data[0]?.count || 0;
            console.log("checkCountActive: ", this.checkCountActive)
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },

    getCheckCount() {
      this.checkedCount = 0;
      for (let i = 0; i < this.responseDataList.length; i++) {
        if (this.responseDataList[i].active === true) {
          this.checkedCount++
        }
      }
    },
    getActiveNotifyTeacher(row) {
      if (row.active) {
        this.checkedCount++
      } else {
        this.checkedCount--;
      }
      if (this.checkCountActive <= this.checkedCount) {
        this.checkActive(row)
      }
    },
    getApprovedNotifyTeacher(row){
      let data = {
        id: row.id,
        approved: row.approved,
      };
      NotifyTeacherService.getApprovedNotifyTeacher(data)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: "success",
            });
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },
    checkActive(row) {
      let data = {
        id: row.id,
        active: row.active,
      };
      NotifyTeacherService.getActiveNotifyTeacher(data)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: "success",
            });
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          });
    },
    handleChangePin(row, boolean) {
      if (boolean) {
        this.handleOpenDialogSetTimePostPin(row.id, boolean);
      } else {
        this.fetchSetPinPost(row.id, boolean);
      }
    },
    handleOpenDialogSetTimePostPin(id, boolean) {
      this.isDialogVisible.setTimePostPin = true;
      this.$refs.SetTimePostPinTeacherExpiration.handleSetInitialData(id, boolean);
    },
    handleDialogSetTimeClose(value) {
      if (value.isSave) {
        this.searchByProperties();
      } else {
        this.setPinPost(value.id, !value.pin);
      }
      this.isDialogVisible.setTimePostPin = false;
    },
    setPinPost(id, boolean) {
      const posts = this.responseDataList;

      for (let i = 0; i <= posts.length; i++) {
        if (posts[i].id === id) {
          posts[i].pin = boolean;
          break;
        }
      }

      this.sortDataPinPost();
    },
    fetchSetPinPost(id, boolean) {
      const param = {
        id: id,
        pin: boolean,
        endPinDate: ""
      }
      NotifyTeacherService.setPinPost(param)
          .then((res) => {
            this.$message({
              message: res.data.message,
              type: "success",
              duration: 5000
            })
            this.searchByProperties();
          })
          .catch((err) => {
            console.log(err.data.message);
          })
    },
    sortDataPinPost() {
      const list = this.responseDataList;
      const listPinPost = [];
      const listPost = [];

      if (list.length > 0) {
        for (let i = 0; i <= list.length; i++) {
          if (list[i]?.pin) {
            listPinPost.push(list[i]);
          } else {
            listPost.push(list[i]);
          }
        }
        const listPinPostSort = this.sortByDateTime(listPinPost);
        const listPostSort = this.sortByDateTime(listPost);

        this.responseDataList = listPinPostSort.concat(listPostSort);
      }
    },
    sortByDateTime(listData) {
      listData.sort((a, b) => new Date(b?.createdDate) - new Date(a?.createdDate));

      return listData;
    }
  },
  beforeMount() {
    this.searchByProperties();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-table.scss";

.nfs-page {
  padding: 4px 0 24px;
}

/* ─── Toolbar card ─────────────────────────────────── */
.nfs-toolbar-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 20px 24px;
  margin-bottom: 20px;
}

/* ─── Table card ───────────────────────────────────── */
.nfs-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 20px 24px 16px;
  margin-bottom: 20px;
}

/* ─── Card head ────────────────────────────────────── */
.nfs-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.nfs-card-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
}

.nfs-card-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
}

.button-click {
  flex-shrink: 0;
}

.button-over {
  border-radius: 10px;
  font-weight: 600;
  padding: 10px 16px;
}

/* ─── Form Grid ────────────────────────────────────── */
.nfs-form-grid {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.nfs-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/deep/ .nfs-form-item .el-form-item__label {
  padding-bottom: 4px;
  font-size: 12.5px;
  color: #475569;
  font-weight: 600;
  line-height: 1.5;
}

/* Input, select bo góc */
/deep/ .nfs-page .el-input__inner,
/deep/ .nfs-page .el-select .el-input__inner {
  border-radius: 10px;
  background: #f8fafc;
  border-color: #e2e8f0;
  transition: all 0.2s ease;
}

/deep/ .nfs-page .el-input__inner:focus,
/deep/ .nfs-page .el-select .el-input__inner:focus {
  border-color: #2563eb;
  background: #ffffff;
}

/deep/ .nfs-page .el-input-group__append {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  background: #f1f5f9;
  border-color: #e2e8f0;
  padding: 0 16px;
  
  .el-button {
    margin: -10px -16px;
    border-radius: 0 10px 10px 0;
    color: #475569;
    
    &:hover {
      color: #2563eb;
    }
  }
}

/* ─── Table ────────────────────────────────────────── */
.nfs-table-wrapper {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #dbeafe;
}

/deep/ .sk-table thead th,
/deep/ .sk-table th {
  background-color: #2563eb !important;
  color: #ffffff !important;
  font-weight: bold;
}

.nfs-title-link {
  font-weight: 600;
  color: #2563eb;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
}

.nfs-file-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #475569;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
}

/* Checkboxes */
/deep/ .nfs-table-checkbox .el-checkbox__inner {
  border-radius: 4px;
  width: 18px;
  height: 18px;
  border-color: #cbd5e1;
}

/deep/ .nfs-table-checkbox.is-checked .el-checkbox__inner {
  background-color: #10b981;
  border-color: #10b981;
}

/deep/ .nfs-table-checkbox--pin.is-checked .el-checkbox__inner {
  background-color: #eab308;
  border-color: #eab308;
}

/deep/ .nfs-table-checkbox .el-checkbox__inner::after {
  height: 9px;
  left: 6px;
  top: 2px;
  width: 4px;
}

/* Badge Trạng thái */
.nfs-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  min-width: 80px;
  
  &--success {
    background-color: #dcfce7;
    color: #15803d;
  }
  
  &--danger {
    background-color: #fee2e2;
    color: #b91c1c;
  }
  
  &--warning {
    background-color: #fef9c3;
    color: #a16207;
  }
}

/* ─── Pagination ──────────────────────────────────── */
.nfs-pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

/deep/ .nfs-pagination .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2563eb;
}
</style>
